import {Component, inject, OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {DataService} from "../../services/data.service";
import moment from "moment/moment";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {LocalStorageService} from "../../services/local-storage.service";
import {AccessService} from "../../services/access.service";

@Component({
  selector: 'app-admin-login',
    imports: [
        FormsModule
    ],
  templateUrl: './admin-login.component.html',
  styleUrl: './admin-login.component.scss'
})
export class AdminLoginComponent implements OnInit {

    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);
    private localStorageService = inject(LocalStorageService);
    private router = inject(Router);
    private accessService = inject(AccessService);

    password: string = '';
    slug!: string|null|undefined;

    ngOnInit(): void {
        console.log(this.route);
        this.slug = this.route.parent?.snapshot.paramMap.get('slug');

        // first check if client exists, if not redirect to home
        this.dataService.request('Client/getBySlug', {
            slug: this.slug,
        }).subscribe(response => {
            if (response.error) {
                //this.toastrService.error(response.error, 'Fehler');
                this.router.navigate(['/']);
            } else {
                // check if token exists
                let token = this.localStorageService.getItem('token');
                if (token) {
                    // check if valid is token
                    console.log('token found, validating');
                    this.accessService.token = token;
                    this.dataService.request('Client/checkToken', {
                        slug: this.slug,
                    }).subscribe(response => {
                        if (response.error) {
                            //this.toastrService.error(response.error, 'Fehler');
                            this.localStorageService.removeItem('token');
                            this.accessService.client = null;
                            this.accessService.token = '';
                        } else {
                            this.accessService.client = response.client;
                            this.router.navigate(['../list'], { relativeTo: this.route });
                        }
                    });
                } else {
                    console.log('no token found');
                }
            }
        });
    }

    login(): void {
        this.dataService.request('Client/login', {
            slug: this.slug,
            password: this.password,
        }).subscribe(response => {
            if (response.error) {
                this.toastrService.error(response.error, 'Fehler');
            } else {
                this.toastrService.success('Anmelden erfolgreich', 'Login');
                this.localStorageService.setItem('token', response.token);
                this.accessService.client = response.client;
                this.accessService.token = response.token;

                this.router.navigate(['../list'], { relativeTo: this.route });
            }
        });
    }
}
